import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { usersFavoriteCleanersQueryKey } from '@/hooks/queries/use-get-users-favorite-cleaners-list.query';

interface DeleteFavoriteCleanerResponse {
  success: boolean;
  message?: string;
}

const deleteUsersFavoriteCleaners = async (
  favoriteId: string
): Promise<DeleteFavoriteCleanerResponse> => {
  const response = await axios.delete(`/users/favorite-cleaners/${favoriteId}`);
  return response.data;
};

export const useDeleteUsersFavoriteCleanersMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteUsersFavoriteCleaners,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: usersFavoriteCleanersQueryKey,
      });
    },
  });
};
